

// vars
var _vars = {
    currentZipCode: '',
    destination: false, // pages that need the zip code
    destinationURL: '', // destination page
    bingMapsAPIKey: bingMapsAPIKey
};

// Form elements
var _elements = {
    $geo_overlay: $('.geo-overlay'), //geo overlay full page
    $geo_close: $('.geo-close'), // geo Overlay 'X'
    $geolocator: $('.geolocator'), // OK, USE MY LOCATION btn
    $geolocatorGo: $('.geolocator-go'), // Go geo 
    $geo_input_global: $('.geo-input') // nav & overlay geo input
};

// get previous url (before user lands to inventory)
var inventory_landing_url = window.location.href;

// pages that need zipGate
// used for OnClick and OnLoad
// var _checkURL = [
//     '/',
//     '/inventory',
//     '/dealer-locator'
// ];


$(document).ready(function () {

    $('.search-inventory-btn, .offer-home img').click(function () {

        // not sure if this is safe to call
        // event.preventDefault();
        // event.stopPropagation();

        // save destination URL to variable
        _vars.destinationURL = $(this).attr('data-destination');

        if (ZipStorage.getZip()) {
            // Zip exists, redirect user
            window.location.href = _vars.destinationURL;
        }
    });

    // Go btn
    $('.geolocator-go').on('click', function (e) {
        geolocator.geoBtnGo($(this));
    });

    // keyboard enter pressed
    _elements.$geo_input_global.keydown(function (e) {
        if (event.keyCode == 13) {
            $(this).blur();
            geolocator.geoBtnGo($(this).next('.geolocator-go'));
        }
    });

    // keyboard enter pressed - zipgate overlay
    $('.geo-search-overlay').keydown(function (event) {
        if (event.keyCode == 13) {
            $(this).blur();
            $(this).siblings('.geolocator-go').click();
        }
    });

    // OK, use my location btn click
    _elements.$geolocator.on('click', function (e) {
        geolocator.getLocation();
    });

    // close Geolocation overlay
    $('.geo-close').on('click', function (e) {
        $('.geo-overlay').toggleClass('no-show');
    });


}); //document ready END





/*
 * *************************************
 *   zipGate START
 *   if geo fails for mobile and desktop
 *   and zip is needed for the page use
 *   geo overlay to request it
 * *************************************   
 */

var zipGate = new function () {

    this.showOverlay = function () {

        console.log('calling showOverlay');
         // console.log(_elements);
        // _elements.$geo_overlay.removeClass('no-show');
        $('.geo-overlay').removeClass('no-show');
        // console.log('calling showOverlay2');

    }

    this.checkURL = function () {
    }

    this.destinationURL = function (path) {
    }

} // zipGate END    




/*
 * *************************************
 *  geolocator START 
 * - OK, USE MY location btn click
 * - HTML5 Geolocation for Mobile
 * - getZipCodeDesktop handler for Desktop
 * *************************************
 */

var geolocator = new function () {

    var lat, long;
    console.log('geolocator');

    // get location/position
    this.getLocation = function () {

        // if mobile user
        if (mobileTest.init()) {

            // if browser supports HTML5 'navigator.geolocation'
            // Use HTML5 'navigator.geolocation' to get lat/long
            if (navigator.geolocation) {
                // get lat/long then call 'geolocator.setPositions()'
                // Only works in 'localhost' or 'https'
                navigator.geolocation.getCurrentPosition(geolocator.setPositions, geolocator.geoBlocked, {
                    timeout: 30000,
                    enableHighAccuracy: true,
                    maximumAge: 75000
                });

            } else {
                // since HTML5 geo is not supported, ask user to input location
                zipGate.showOverlay();
            }

        }
            // if desktop - call getZipCodeDesktop handler
        else {
            getZipCodeDesktop.ajaxCall();
        }

    } // this.getLocation END


    this.geoBlocked = function () {
        console.log('geo Blocked by user');

        // hide "Ok, USE MY LOCATION" btn
        // _elements.$geolocator.addClass('no-show')

        // since HTML5 geo is BLOCKED by user
        zipGate.showOverlay();

    } //geoBlocked


    // for Mobile
    // convert lat/long from positions using 'getPinCode'
    this.setPositions = function (position) {
        lat = position.coords.latitude;
        long = position.coords.longitude;

        // Call bing to convert to Zip
        getPinCode(lat, long, function (res, lat, lon) {
            // call updateCookieZip to update cookie
            setZip.updateAll(res);
        });
    }

    // geolocation btn click
    this.geoBtnGo = function (thisObj) {
        console.log('geoBtnGo');

        // var $input = thisObj.prev('.search-box');
        var $input = $('.search-box');

        // var $input = $('#searchBoxContainer-overlay .search-box');
        var lat = null,
            lon = null;
        // $('.geo-input-error-wrapper').removeClass('active');
        // Validate: is there val() in input
        if ($input.val()) {

            var zip = $input.val();
            var zipRegex = /^\d{5}$/;

            // check input for numbers only
            if (!zipRegex.test(zip)) {
                errorMessage.show('Please enter a numeric 5-digit zip code only.');
                return;
            }

            //getLatLonFromQuery($input.data('suggestion') || $input.val(), function(lat, lon, country) {
            getLatLonFromQuery($input.val(), function (lat, lon, country) {

                if (country !== "United States") {
                    errorMessage.show('Zip code is outside of United States.');
                    return;
                }

                getPinCode(lat, lon, function (res, lat, lon) {

                    //sometimes api returns incorrect zip. So, if user searched for a zip, then show it directly
                    var inputText = $input.val();
                    if (inputText.length > 0 && /^\d{5}$/.test(inputText.trim())) {
                        res = inputText;
                    }

                    // call updateCookieZip to update Local Storage
                    setZip.updateAll(res);

                });

            });



        } else {

            //input is empty - no val in input 
            errorMessage.show('Please enter a zip code.');

        }

    }

}
/* geolocator END */




/*
 * *************************************
 *  getZipCodeDesktop - Zip by IP Location handler START
 * - get zip code for desktop user from handler
 *
 * *************************************
 */
var getZipCodeDesktop = new function () {

    this.ajaxCall = function () {

        console.log('ajaxCall get-zip-by-ip-address.ashx');

        $.ajax({
            type: 'POST',
            dataType: "json",
            url: '/api/geolocation/getzipfromipaddress',
            data: {},

            complete: function (data, status) {

                console.log('ajax data zipcode: ' + JSON.stringify(data));
                data = data.responseJSON;
                if (data.status == 'failure'){
                    // since ajax call failed, ask user to input location which logic is in inventory
                    if (_vars.destinationURL != '') {
                        window.location.href = _vars.destinationURL;
                    }

                } else {
                    if (status == 'success') {
                        // data = data.responseJSON;
                        console.log('282: ', data);
    
                        // call updateCookieZip to update cookie
                        getLatLon(data.zip_code, function (lat, lon, zip) {
                            setZip.updateAll(zip);
                        });
    
                    } else {
    
                        // since ajax call failed, ask user to input location
                        zipGate.showOverlay();
                    }
                }
 
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // since ajax call failed, ask user to input location
                zipGate.showOverlay();
            }
        });

    }
}
/* getZipCodeDesktop - IP Location handler END */


/*
 * *************************************
 * setZip
 * - update Cookie with zip code
 * *************************************
 */
var setZip = new function () {

    this.updateAll = function (zipCode) {

        // update zip in local storage
        if (zipCode) {
            ZipStorage.setZip(zipCode);
        }

        // after update, redirect user to destination
        if (_vars.destinationURL != '') {
            window.location.href = _vars.destinationURL;
        }

        var zipReadyEvent = new Event(this.ZIP_READY_EVENT_NAME);
        document.dispatchEvent(zipReadyEvent);
    } // updateAll END

} /* setZip  END */




/*
 * *************************************
 * mobileTest
 * 
 * *************************************
 */
var mobileTest = new function () {
    this.init = function () {
        var isMobile = false;
        //Detect mobile
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        if (isMobile) {
            return true;
        } else {
            return false;
        }
    }
} /* mobileTest END */



/*
 * *************************************
 * check if zip code is in Cookie
 * *************************************
 */
var zipCheckCookie = new function () {
    this.init = function () {
        // look for zipcode in local storage
        _vars.currentZipCode = ZipStorage.getZip();
        console.log('initial cookie zip check: ' + _vars.currentZipCode);
        if (_vars.currentZipCode) {
            // init this page - zip is ready
            $('body').trigger('app.zipReady');

            return true;
        } else {
            return false;
        }
    }
} /* zipCheckCookie END */


//} //constructor() END

//} // class geolocation END



/*
 * *************************************
 *  BING MAP START
 *  BING map code will be here 
 * *************************************      
 */

function CallRestService(request, callback) {
    $.ajax({
        url: request,
        dataType: "jsonp",
        jsonp: "jsonp",
        success: function (r) {
            callback(r);
        },
        error: function (e) {
            // console.log(e.statusText);
            errorMessage.show('API error');
        }
    });
} // CallRestService END


function getPinCode(lat, lon, callback) {

    // CallRestService('https://dev.virtualearth.net/REST/v1/Locations/' + lat + ',' + lon + '?key=' + bingMapsAPIKey_AutoComplete,
    CallRestService('https://dev.virtualearth.net/REST/v1/Locations/' + lat + ',' + lon + '?key=' + _vars.bingMapsAPIKey,

        function (res) {
            //console.log('getPinCode:', res);
            if (res.resourceSets["0"].estimatedTotal > 0) {
                callback(res.resourceSets[0].resources[0].address.postalCode, lat, lon);
            } else {
                errorMessage.show('Zip code does not exist on Bing Maps!');
            }

        })
}


function getLatLon(zip, callback) {

    // CallRestService('https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + zip + '&key=' + bingMapsAPIKey_AutoComplete,
    CallRestService('https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + zip + '&key=' + _vars.bingMapsAPIKey,

        function (res) {
            //console.log('getLatLon:', res);
            if (res.resourceSets["0"].estimatedTotal > 0) {
                callback(res.resourceSets[0].resources[0].geocodePoints[0].coordinates[0],
                    res.resourceSets[0].resources[0].geocodePoints[0].coordinates[1], zip);
            } else {
                errorMessage.show('Zip code does not exist on Bing Maps!');
            }
        })
}


function getLatLonFromQuery(query, callback) {

    CallRestService('https://dev.virtualearth.net/REST/v1/Locations?q=' + encodeURIComponent(query) + '&key=' + _vars.bingMapsAPIKey,

        function (res) {

            if (res.resourceSets["0"].estimatedTotal > 0) {

                // if any resource has entityType:postalcode1 then use that else use first 
                var resources = res.resourceSets["0"].resources;
                var resource;
                for (var i = 0; i < resources.length; i++) {

                    if (resources[i].entityType.indexOf('Postcode') >= 0) {
                        resource = resources[i];
                        break;
                    }
                }

                if (resource == null) {
                    resource = resources["0"];
                }

                callback(resource.geocodePoints["0"].coordinates["0"],
                    resource.geocodePoints["0"].coordinates["1"], resource.address.countryRegion);
            } else {
                errorMessage.show('Zip code does not exist on Bing Maps!');
            }
        })
}

/*  BING MAP  END      */



/*
 * *************************************
 *  errorBox START 
 * *************************************
 */

var errorMessage = new function () {

    this.show = function (message) {
        $('.zip-error').html(message);
    }

    this.hide = function () {
        $('.zip-error').html('');
    }

}


// use cookies to save zip
var cookieStorage = new function () {
    this.getCookie = function (key) {

        var _currentCookie = Cookies.get(key);
        if (_currentCookie) {
            console.log('cookie is defined if: ' + _currentCookie);
            return Cookies.get(key);
        } else {
            console.log('cookie is undefined else');
            return false;
        }

    }
    this.setCookie = function (key, value) {
        console.log('setCookie ' + key + ' ' + value)
        Cookies.set(key, value);
    }
};


//global function to setitem in cookie
function cookieSetItemCommon(key, value) {
    console.log('Using SET Cookies');
    cookieStorage.setCookie(key, value);
};

//global function to getitem from cookie
function cookieGetItemCommon(key) {
    if (key != null) {
        console.log('Using GET Cookies');
        return cookieStorage.getCookie(key);
    } else {
        console.log('cookieGetItemCommon Key Null');
    }
};